(function () {
  if (window.__rtFeaturedBlogBound) {
    return;
  }
  window.__rtFeaturedBlogBound = true;

  var slickOptions = {
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    touchMove: true,
    accessibility: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  };

  function syncBlogSection(sectionEl) {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn || !window.jQuery.fn.slick) {
      return false;
    }
    var $ = window.jQuery;
    var enableSlider = sectionEl.getAttribute('data-enable-slider') !== 'false';
    var carouselElement = sectionEl.querySelector('.featured-articles');
    if (!carouselElement || carouselElement.children.length === 0) {
      return true;
    }

    if (!enableSlider) {
      if ($(carouselElement).hasClass('slick-initialized')) {
        $(carouselElement).slick('unslick');
      }
      return true;
    }
    if (window.innerWidth <= 600) {
      if ($(carouselElement).hasClass('slick-initialized')) {
        $(carouselElement).slick('unslick');
      }
    } else if (!$(carouselElement).hasClass('slick-initialized')) {
      $(carouselElement).slick(slickOptions);
    }
    return true;
  }

  function initAll() {
    var ready = true;
    document.querySelectorAll('[id^="rt-featured_blog-"]').forEach(function (sectionEl) {
      if (!syncBlogSection(sectionEl)) {
        ready = false;
      }
    });
    return ready;
  }

  function tryInit(attemptsLeft) {
    if (initAll() || attemptsLeft <= 0) {
      return;
    }
    setTimeout(function () {
      tryInit(attemptsLeft - 1);
    }, 50);
  }

  function start() {
    tryInit(40);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  if (!window.__rtFeaturedBlogResizeBound) {
    window.__rtFeaturedBlogResizeBound = true;
    window.addEventListener('resize', function () {
      if (typeof window.jQuery !== 'undefined' && window.jQuery.fn && window.jQuery.fn.slick) {
        initAll();
      }
    });
  }

  document.addEventListener('shopify:section:load', start);
})();
